import { render } from "./Shipments.vue?vue&type=template&id=276533c9&ts=true"
import script from "./Shipments.vue?vue&type=script&lang=ts"
export * from "./Shipments.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__